import React, { useCallback, useEffect } from 'react';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';
import { AxiosError } from 'axios';
import { Location } from 'history';
import client from 'lib/CommonApi/client';
import { exceptionEventWeb, hideProgressWeb, showProgressWeb } from 'common/appInterface';
import stringUtils from 'common/stringUtils';
// import "assets/css/loading.scss";

const IntroPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** Query */
  const query = queryString.parse(location.search);

  const inquiryAllProductImagePath = useCallback(async () => {
    try {
      const cacheItem = localStorage.getItem("100921_B");

      if (!cacheItem) {
        await client.get(`/api/nologin/product/inquiryProductImagePathList`, {}).then((response) => {
          if (response.data.code === '00') {
            console.log('Inquiry Product Image Path List SUCCESS');

            const resData = response.data.response;

            // 카드 이미지 path 를 localStorage에 저장
            for (let i = 0; i < resData.length; i++) {
              localStorage.setItem(resData[i].cardProductCode + "_" + resData[i].designDivisionCode, resData[i].externalHost + resData[i].cardImgPath);
            }
          } else {
            console.error('Inquiry Product Image Path List FAILED' + response.data.message ?? "");
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  // 세션생성
  const callIntro = useCallback(async () => {
    if (stringUtils.checkValueNull(query.pid)) {
      navigate('/nologin/product', { state: { query: query } });
    } else {
      showProgressWeb();
      localStorage.clear();
      await client.get('/api/app/intro', { params: query }).then((response) => {
        if (response.data.code === '00') {
          console.log('INTRO SUCCESS');

          let result = response.data.response;
          if (result.ableCardCount > 0) {
            if (query.menuCode === '9') {
              navigate(
                '/product',
                {
                  state: {
                    query: query,
                    apply: {
                      cardMemberNo: result.cardMemberNo,
                      requestIssueDivisionCode: '12'
                    },
                    from: location.pathname,
                    swiperIndex: 0,
                    tabIndex: '1'
                  }
                }
              );
            } else {
              // if(result.ableCardCount > 1 && query.menuCode)
              //   delete query.menuCode;
              if (result.swiperIndex === -1) {
                navigate(
                  '/main',
                  {
                    state: {
                      query: query,
                      swiperIndex: 0,
                      tabIndex: '1',
                      from: location.pathname,
                      cardProductCode: query.cardProductCode
                    }
                  }
                );
              } else {
                const { menuCode: code, navigatePath, cardProductCode } = query;
                const menuCode = code === '1' ? '2' : (code === '2' ? '1' : (code ?? '1'));
                navigate(
                  '/main',
                  {
                    state: {
                      query: query,
                      swiperIndex: result.swiperIndex,
                      tabIndex: menuCode,
                      from: location.pathname,
                      linkOpenMenu: navigatePath,
                      cardProductCode: cardProductCode
                    }
                  }
                );
              }
            }
          } else {
            if (query.menuCode) delete query.menuCode;
            navigate(
              '/product',
              {
                state: {
                  query: query,
                  apply: {
                    cardMemberNo: result.cardMemberNo,
                    requestIssueDivisionCode: '11'
                  },
                  from: location.pathname,
                  swiperIndex: 0,
                  tabIndex: '1'
                }
              }
            );
          }
        } else {
          exceptionEventWeb(response.data.code, response.data.message, '2');
        }
      }).catch((e: AxiosError) => {
        console.log(e);
        exceptionEventWeb('99', 'Page Loading Error [' + e + ']', '2');
      }).finally(() => {
        hideProgressWeb();
      });
    }
  }, [navigate, location, query]);

  // 최초실행
  useEffect(() => {
    console.log('QUERY PARAMS');
    console.log(query);
    callIntro();

    /*
    * 카드 상품 이미지 조회
    * */
    inquiryAllProductImagePath();

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
    </div>
  );
};

export default IntroPage;